import {
  JORNADA_ITEM_TIPOS,
} from '../constants/jornadaItemTipo';

/** Origem mobile: algum item tem captura ou coordenadas. */
export const isJornadaOrigemMobile = (itens = []) =>
  (itens || []).some(
    (item) => item?.capturadoEm
      || item?.latitude
      || item?.longitude,
  );

export const itensByTipo = (itens = []) =>
  (itens || []).reduce((acc, item) => {
    if (item?.tipo) acc[item.tipo] = item;
    return acc;
  }, {});

export const timesFromItens = (itens = []) => {
  const byTipo = itensByTipo(itens);
  return JORNADA_ITEM_TIPOS.reduce((acc, { tipo, timeField }) => {
    acc[timeField] = byTipo[tipo]?.horario || null;
    return acc;
  }, {});
};

/** Monta itens só com tipo + horário (create web / edit web). */
export const buildItensFromTimes = (values, existingItens = []) => {
  const byTipo = itensByTipo(existingItens);
  return JORNADA_ITEM_TIPOS
    .map(({ tipo, timeField }) => {
      const horario = values[timeField];
      if (!horario) return null;
      const prev = byTipo[tipo];
      return {
        ...(prev?.id ? { id: prev.id } : {}),
        tipo,
        horario,
      };
    })
    .filter(Boolean);
};

export const formatEnderecoItem = (enderecoJson) => {
  if (!enderecoJson) return null;
  let data = enderecoJson;
  if (typeof enderecoJson === 'string') {
    try {
      data = JSON.parse(enderecoJson);
    } catch (e) {
      return enderecoJson;
    }
  }
  if (typeof data !== 'object' || data == null) return null;
  const parts = [
    data.rua || data.road || data.logradouro,
    data.numero || data.number,
    data.bairro || data.suburb || data.neighbourhood,
    data.cidade || data.city || data.localidade,
    data.estado || data.state || data.uf,
  ].filter(Boolean);
  if (parts.length) return parts.join(', ');
  if (data.formatted || data.display_name || data.endereco) {
    return data.formatted || data.display_name || data.endereco;
  }
  return null;
};

export const mapsUrlFromItem = (item) => {
  if (!item) return null;
  if (item.latitude && item.longitude) {
    return `https://www.google.com/maps?q=${encodeURIComponent(`${item.latitude},${item.longitude}`)}`;
  }
  const endereco = formatEnderecoItem(item.enderecoJson);
  if (endereco) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(endereco)}`;
  }
  return null;
};

export const computeJornadaTotalMinutes = ({
  inicioJornada,
  inicioIntervalo,
  finalIntervalo,
  finalJornada,
}, convertTimeToMinutes) => {
  const inicioJornadaMinutes = convertTimeToMinutes(inicioJornada);
  const inicioIntervaloMinutes = convertTimeToMinutes(inicioIntervalo);
  const finalIntervaloMinutes = convertTimeToMinutes(finalIntervalo);
  const finalJornadaMinutes = convertTimeToMinutes(finalJornada);

  const first = (inicioJornadaMinutes && inicioIntervaloMinutes
    && inicioIntervaloMinutes > inicioJornadaMinutes)
    ? inicioIntervaloMinutes - inicioJornadaMinutes
    : null;
  const second = (finalJornadaMinutes && finalIntervaloMinutes
    && finalJornadaMinutes > finalIntervaloMinutes)
    ? finalJornadaMinutes - finalIntervaloMinutes
    : null;

  if (first === null && second === null) return null;
  return (first || 0) + (second || 0);
};
